<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }" style="margin-top: 75px">
    <TheAsideBarMenu />
    <CWrapper class="justify-content-between">
      <div>
        <TheHeader />
        <main class="justify-content-between position-relative">
          <CContainer fluid class="p-0">
            <CWrapper class="justify-content-between">
              <ToastMessage />
              <router-view :key="$route.path"></router-view>
            </CWrapper>
          </CContainer>
        </main>
      </div>
      <TheFooter />
    </CWrapper>
  </div>
</template>

<script>
import ToastMessage from '@/components/ToastMessage'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAsideBarMenu from './TheAsideBarMenu'

export default {
  name: 'TheContainer',
  components: {
    ToastMessage,
    TheHeader,
    TheFooter,
    TheAsideBarMenu,
  },
  created() {
    //TODO melhorar evitar que se tenha que enviar isso para zerar o setToastMessage
    this.$store.commit('setToastMessage', null)
  },
}
</script>

<style>
.container-fluid {
  /* max-width: 1920px; */
}
</style>
